/*=========================================================================================
  File Name: module-usertax-actions.js
  Description: UserTax Module Actions
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/
import ServiceRegisPayAPI from '@/api/ServiceRegisPayAPI.js';
import ServiceRegisDecAPI from '@/api/ServiceRegisDecAPI.js';
import ServiceRegisBankAPI from '@/api/ServiceRegisBankAPI.js';
import ContactAdditionalAPI from '@/api/ContactAdditionalAPI.js';
import httpClient from '../../api/axios-httpclient';
import { MSEnum } from '@/common/enumeration';
import PayFileAPI from '@/api/PayFileAPI.js';
import DecFileAPI from '@/api/DecFileAPI.js';
import { ModuleTaxRegis } from '../module-const';
import store from '../store';

export default {
	/**
	 * Lấy ra danh sách lịch sử đăng ký
	 */
	loadRegisHistory: async function (context, payload) {
		let res = await httpClient.postAsync(
			{
				url: ServiceRegisPayAPI.getAPIUrl() + '/historypaging',
				data: payload,
			},
			true
		);

		if (res.Success) {
			context.commit('updateData', res);
		}

		if (res && res.Success) {
			// Trả kết quả
			return res.Data;
		}

		return null;
	},

	/**
	 * Lấy ra thông tin người nộp thuế
	 */
	loadServiceRegisTaxPay: async function (context, payload) {
		let res = await httpClient.getAsync(
			{
				url: ServiceRegisPayAPI.getAPIUrl() + '/getServiceRegisTaxPay',
				params: payload,
			},
			false
		);

		if (res && res.Success) {
			// Trả kết quả
			return res.Data;
		}

		return null;
	},

	/**
	 * Lấy ra thông tin đang chờ đăng ký
	 */
	getServiceRegisWaiting: async function (context, payload) {
		let res = await httpClient.getAsync(
			{
				url: ServiceRegisPayAPI.getAPIUrl() + '/getServiceRegisWaiting',
				params: payload,
			},
			true,
			false
		);
		if (res && res.Success) {
			// Trả kết quả
			return res.Data;
		}

		return null;
	},

	/**
	 * Thực hiện tạo file xml mang đi ký số khi nộp thuế
	 */
	createXMLRegis: async function (context, payload) {
		let res = await httpClient.postAsync(
			{
				url: ServiceRegisPayAPI.getAPIUrl() + '/createxml',
				data: payload,
			},
			true
		);

		// Trả kết quả
		return res;
	},

	/**
	 * thực hiện gửi thông tin đăng ký sang queue để xử lý: gọi sang api Pay
	 */
	registration: async function (context, payload) {
		let res = await httpClient.postAsync(
			{
				url: ServiceRegisPayAPI.getAPIUrl() + '/registration',
				data: payload,
			},
			true
		);

		// Trả kết quả ra ngoài
		return res && res.Success;
	},

	/**
	 * Thực hiện tạo file XML mang đi kyso ký khi đăng ký khai thuế qua mạng
	 * */
	createXMLRegisDecTax: async function (context, payload) {
		let res = await httpClient.postAsync(
			{
				url: ServiceRegisDecAPI.getAPIUrl() + '/createxml',
				data: payload,
			},
			true
		);

		// Trả kết quả
		return res;
	},

	/**
	 * Thực hiện gửi thông tin đăng ký khai thuế sang queue để xử lý: gọi sang api Dec
	 */
	registrationDecTax: async function (context, payload) {
		let res = await httpClient.postAsync(
			{
				url: ServiceRegisDecAPI.getAPIUrl() + '/registration',
				data: payload,
			},
			true
		);

		// Trả kết quả ra ngoài
		return res && res.Success;
	},

	/**
	 * Thực hiện lấy ra danh sách ngân hàng đi theo người nộp thuế
	 */
	loadBankByTaxCode: async function (context, payload) {
		let res = await httpClient.postAsync({
			url: ServiceRegisBankAPI.getAPIUrl() + '/getbank',
			data: payload,
		});

		if (res && res.Success) {
			context.commit('bankListByTaxCode', res);
			return res.Data;
		}

		// Trả kết quả
		return null;
	},

	/**
	 * Thực hiện lấy ra danh sách thông tin liên hệ bổ sung
	 */
	loadContactAdditional: async function (context, payload) {
		let res = await httpClient.getAsync(
			{
				url: ContactAdditionalAPI.getAPIUrl() + '/getallcontact',
				params: payload,
			},
			false,
			false
		);

		if (res && res.Success) {
			if (payload.ContactType === MSEnum.ContactType.DECLERATION) {
				context.commit('updateDecTaxContactAdditionalList', res);
			} else {
				context.commit('updatePayTaxContactAdditionalList', res);
			}
		}

		// Trả kết quả
		return res.Data;
	},

	/**
	 * Lấy ra thông tin người khai thuế
	 * */
	loadServiceRegisTaxDec: async function (context, payload) {
		let res = await httpClient.getAsync(
			{
				url: ServiceRegisDecAPI.getAPIUrl() + '/getServiceRegisTaxDec',
				params: payload,
			},
			true
		);

		if (res && res.Success) {
			if (res.Data && Object.keys(res.Data).length > 0) {
				context.commit('updateIsRegisDeclareTax', true);
			}
		}

		// Trả kết quả
		return res.Data;
	},

	/**
	 * Hàm này dùng để kiểm tra xem hồ sơ khai thuế có đang đăng ký/thay đổi/bổ sung/ngừng dịch vụ hay không
	 */
	checkWaitingProcessDec: async function (context, payload) {
		let res = await httpClient.getAsync(
			{
				url: ServiceRegisDecAPI.getAPIUrl() + '/iswaitingprocess',
				params: payload,
			},
			false,
			false
		);

		if (res && res.Success && res.Data) {
			context.commit('updateWaitingProcessDec', res.Data);
		} else {
			context.commit('updateWaitingProcessDec', false);
		}

		return res;
	},

	checkWaitingProcessPay: async function (context, payload) {
		let res = await httpClient.getAsync({
			url: ServiceRegisPayAPI.getAPIUrl() + '/iswaitingprocess',
			params: payload,
		});

		if (res && res.Success && res.Data) {
			context.commit('updateWaitingProcessPay', res.Data);
		} else {
			context.commit('updateWaitingProcessPay', false);
		}

		return res;
	},

	downloadPayTaxServiceRegisHistory: function (context, payload) {
		let res = httpClient
			.postAsync({
				url: ServiceRegisPayAPI.getAPIUrl() + '/download',
				data: payload,
			})
			.then((res) => {
				if (res && res.Success && res.Data) {
					PayFileAPI.download(res.Data);
				}
			});
	},

	downloadDecTaxServiceRegisHistory: function (context, payload) {
		let res = httpClient
			.postAsync({
				url: ServiceRegisDecAPI.getAPIUrl() + '/download',
				data: payload,
			})
			.then((res) => {
				if (res && res.Success && res.Data) {
					DecFileAPI.download(res.Data);
				}
			});
	},

	previewNotification: async function (context, notification) {
		if (notification.TypeServiceTvan == MSEnum.TaxType.TaxPay) {
			let res = await httpClient.postAsync({
				url: ServiceRegisPayAPI.getAPIUrl() + '/previewnotification',
				data: notification,
			});

			if (res && res.Success && res.Data) {
				return (
					PayFileAPI.getAPIUrl() + '/getnotification?key=' + res.Data
				);
			}
		} else {
			let res = await httpClient.postAsync({
				url: ServiceRegisDecAPI.getAPIUrl() + '/previewnotification',
				data: notification,
			});

			if (res && res.Success && res.Data) {
				return (
					DecFileAPI.getAPIUrl() + '/getnotification?key=' + res.Data
				);
			}
		}

		return null;
	},

	previewHistory: async function (context, data) {
		if (data.Type == MSEnum.TypeServiceTvanEnum.PAYMENT) {
			let res = await httpClient.postAsync({
				url: ServiceRegisPayAPI.getAPIUrl() + '/previewhistory',
				data: data,
			});

			if (res && res.Success && res.Data) {
				return (
					PayFileAPI.getAPIUrl() +
					'/getserviceregishistory?key=' +
					res.Data
				);
			}
		} else {
			let res = await httpClient.postAsync({
				url: ServiceRegisDecAPI.getAPIUrl() + '/previewhistory',
				data: data,
			});

			if (res && res.Success && res.Data) {
				return (
					DecFileAPI.getAPIUrl() +
					'/getserviceregishistory?key=' +
					res.Data
				);
			}
		}

		return null;
	},

	getServiceRegisHistoryByTaxCode: async function (context, data) {
		let res = await httpClient.getAsync({
			url:
				ServiceRegisDecAPI.getAPIUrl() +
				'/getserviceregishistorybytaxcode',
			params: data,
		});

		if (res && res.Success && res.Data) {
			context.commit('updateIsRegisDeclareTax', true);
			return res.Data;
		} else {
			context.commit('updateIsRegisDeclareTax', false);
			return null;
		}
	},

	checkDecTax: async function (context, payload) {
		context.commit('setDecTaxCheckCompleted', false);
		//Có hiển thị loading hay không
		let isLoading = payload && payload.IsLoading;

		//Lấy dữ liệu
		let res = await httpClient.getAsync(
			{
				url: ServiceRegisDecAPI.getAPIUrl() + '/checkdectax',
				params: payload,
			},
			isLoading,
			false
		);

		if (res && res.Success && res.Data) {
			//Cập nhật dữ liệu
			context.commit('updateDecRegis', res.Data);

			//IsWaitingProcess
			context.commit(
				'updateWaitingProcessDec',
				res.Data.IsWaitingProcess
			);

			//IsRegisterDecTax
			store.commit(
				`${ModuleTaxRegis}/updateHadRegisteredDeclaration`,
				res.Data.IsRegisterDecTax
			);

			//ServiceRegisInfo
			context.commit('updateServiceRegisTaxDec', {
				Data: res.Data.ServiceRegisInfo,
			});

			//isRegisDeclareTax
			context.commit(
				'updateIsRegisDeclareTax',
				res.Data.IsServiceRegisInfo
			);

			context.commit('setDecTaxCheckCompleted', true);
			return res.Data;
		} else {
			context.commit('setDecTaxCheckCompleted', true);
			return null;
		}
	},
	checkPayTax: async function (context, payload) {
		context.commit('setPayTaxCheckCompleted', false);
		//Có hiển thị loading hay không
		let isLoading = payload && payload.IsLoading;

		//Lấy dữ liệu
		let res = await httpClient.getAsync(
			{
				url: ServiceRegisPayAPI.getAPIUrl() + '/checkpaytax',
				params: payload,
			},
			isLoading,
			false
		);

		if (res && res.Success && res.Data) {
			//Cập nhật dữ liệu
			context.commit('updatePayRegis', res.Data);

			//IsWaitingProcess
			context.commit(
				'updateWaitingProcessPay',
				res.Data.IsWaitingProcess
			);

			//ServiceRegisInfo
			if (res.Data.ServiceRegisInfo) {
				context.commit('updateServiceRegisTaxPay', {
					Data: res.Data.ServiceRegisInfo,
				});

				context.commit('updateIsRegisServicePayTax', true);
			} else if (res.Data.ServiceRegisHistory) {
				context.commit('updateIsRegisServicePayTax', true);
			}

			//Load Banks
			context.commit('bankListByTaxCode', {
				Data: res.Data.ServiceRegisBankInfos,
			});

			context.commit('setPayTaxCheckCompleted', true);
			return res.Data;
		} else {
			context.commit('setPayTaxCheckCompleted', true);
			return null;
		}
	},
	/**
	 * Kiểm tra có bản đăng ký bổ sung ngân hàng nào mà chưa được tct,ngân hàng xác nhận không?
	 */
	checkAffect: async function (context, payload) {
		let res = await httpClient.getAsync(
			{
				url: ServiceRegisPayAPI.getAPIUrl() + '/checkaffect',
				params: payload,
			},
			true,
			false
		);
		if (res && res.Success) {
			return res.Data;
		}

		// Trả kết quả
		return false;
	},
};
